import { Outlet } from 'react-router-dom';
import { useAuth } from '@/context/auth-context';
import { Button } from '@/components/ui/button';
import { Sidebar, useSidebar } from '@/components/sidebar';
import { LogOut, Menu } from 'lucide-react';
import { APP_NAME } from '@worktracker/shared';
import { cn } from '@/lib/utils';

export function Layout() {
  const { user, logout } = useAuth();
  const { collapsed, openMobile } = useSidebar();

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-40 border-b border-border bg-white/90 backdrop-blur-[12px] shadow-sm">
        <div className="flex h-14 items-center justify-between px-4">
          <div className="flex items-center gap-3">
            {/* Hamburger menu — mobile only */}
            <button
              type="button"
              onClick={openMobile}
              className="flex items-center justify-center min-h-[44px] min-w-[44px] rounded-lg text-muted-foreground hover:bg-accent hover:text-accent-foreground md:hidden"
              aria-label="Open menu"
            >
              <Menu className="h-5 w-5" />
            </button>
            <img src="/logo.png" alt="WillDesign" className="h-8" />
            <span className="text-base font-semibold tracking-tight">{APP_NAME}</span>
          </div>
          {user && (
            <div className="flex items-center gap-3">
              {user.avatar && (
                <img
                  src={user.avatar}
                  alt={user.githubUsername}
                  className="h-8 w-8 rounded-full ring-2 ring-brand-teal/20"
                />
              )}
              <span className="hidden sm:inline text-sm text-muted-foreground">
                {user.name || user.githubUsername}
              </span>
              <Button variant="ghost" size="sm" onClick={logout} aria-label="Sign out">
                <LogOut className="h-4 w-4" />
                <span className="hidden md:inline">Sign out</span>
              </Button>
            </div>
          )}
        </div>
      </header>
      <Sidebar />
      {/* Mobile: no margin. Tablet: ml-16 (icon sidebar). Desktop: ml-16 or ml-56. */}
      <main
        className={cn(
          'px-4 py-6 transition-all duration-200 md:px-6 md:ml-16',
          !collapsed && 'lg:ml-56',
        )}
      >
        <div className="mx-auto max-w-[960px]">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
